<template>
  <v-card :disabled="disabled" :flat="flat">
    <v-card-text class="pa-0">
      <v-list-item class="pa-0" @click="$emit('clicked')">
        <v-list-item-avatar class="ma-0">
          <v-icon>{{ icon }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>{{ text }}</v-list-item-title>
        <v-list-item-action>
          <v-icon>mdi-chevron-right</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CardListItem',
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>

</style>